import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Base plan price
   */
  basePlanPrice: string;
  /**
   * Current balance
   */
  currentBalance: string;
};

const Unpaid = ({ basePlanPrice, currentBalance }: Props) => {
  const { t } = useTranslation('subscriptions-manager');

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.base_plan_price'),
        }}
        value={{
          value: basePlanPrice,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.current_balance'),
        }}
        value={{
          value: currentBalance,
          color: 'danger.dark',
          fontWeight: 3,
        }}
      />
    </Box>
  );
};

export default Unpaid;
